// extracted by mini-css-extract-plugin
export default {"gstNumberBox":"gstNumber_gstNumberBox__YYo4E"};